import React from 'react';
import pt from 'prop-types';
import { Section } from 'components/section';

export default class AppStagedReleaseSection extends React.PureComponent {
  static propTypes = {
    version: pt.string,
  };

  getTitle() {
    return 'Reviewing release';
  }

  getSubtitle() {
    const { version } = this.props;

    return `Version ${version} is under review`;
  }

  render() {
    return <Section title={this.getTitle()} subtitle={this.getSubtitle()} />;
  }
}
